<template>
  <v-col v-bind:style="{'background': GetColorHeader() }" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px solid #000000;" >{{ GetEjecucion }}
      <v-row  class="pa-0 ma-0 py-0 my-0" no-gutters > 
    <!-- col header 1   -->
    <v-col class="pa-0 ma-0 py-0 my-0 "  cols="12" md="4" sm="4" >
      <!------------------------------------------ Documentos descripcion-->
          <v-combobox class="pt-2 fontSize13" hide-details autocomplete="off" dense outlined label="Documentos:" :items="RDocumento"
            item-text="desop" :rules="[$rules.required]"
            v-model="headerFactura.documento" @blur="SelctCbDocumento" @focus="cargarDocumento"  
            v-on:blur="DataRetornInfHeaderFactura"  @change="changeDocumentoInfFact(headerFactura.documento)"
            v-on:change="DataRetornInfHeaderFacturaChange('changeDocumento')"
            id="formdisabledInput" :disabled="editando"
          >
                  <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.desop = `${item.item.operacion.modulo.trim()} - ${item.item.descripcion.trim()} ${item.item.codigo} ` }}</span>
                  <span class="fontSize13"> <b>{{ item.item.operacion.modulo.trim()}}</b> - {{item.item.descripcion.trim()}}</span>
                  </template>
                  
                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre"> <b>{{ item.operacion.modulo.trim()}}</b> - {{item.descripcion.trim()}}</span>
                    

                  </template>


            <template v-slot:prepend>
              <i style="font-size: 20px" class="fa fa-book"></i>
            </template>
          </v-combobox>
          <!------------------------------------------ fn Documentos -->
          <!------------------------------------------ Cliente  background-color="white"-->
          <v-combobox ref="RefTextFieldBuscaCliente"  autocomplete="off"  class="py-2 fontSize13" hide-details
                        color="grey darken-4" dense outlined label="Cliente:" :items="RCliente" item-text="codnom"
                        style="font-size: 13px;" v-model="headerFactura.cliente" @blur="SelctCbClienteBuscar"
                        @change="getChangeClienteBusqueda(headerFactura.cliente)" 
                        v-on:change="DataRetornInfHeaderFacturaChange('changeCliente')"
                        v-on:blur="DataRetornInfHeaderFactura"
                        @focus="cargarClienteBusqueda" @keyup="CbFilcliente" :rules="[$rules.required]"
                        id="formdisabledInput" :disabled="editando" no-filter>
                        <template v-slot:prepend>
                                <i style="font-size: 20px" class="fa fa-user-circle"></i>
                              </template>
                        <!-- margin-top="50px"style="font-size: 14px;" -->
                        <template slot="item" slot-scope="item">
                          <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                          <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>
                            style="border: 1px dashed  #616161;"
                              -->
                          <v-col style="border: 1px solid #000000; font-size: 13px; " class="pa-0 ma-0 py-0 my-0"
                            cols="12" md="12" sm="12">
                            <p class="pa-0 ma-0 py-0 my-0"><b>NOMBRE:
                                {{ item.item.nombre }}</b></p>

                            <span class="pa-0 ma-0 py-0 my-0">
                              <span><b>TEL.: </b>
                                {{ selectTelefonoCliente(item.item) }}</span>
                              <span><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                            </span>
                            <p class="pa-0 ma-0 py-0 my-0"><b>DIRECCIÓN: </b>
                              {{ item.item.direccion }} </p>
                            <span v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"><b> ARS
                                :{{ item.item.ars.nombre }}</b></span>
                            <span v-if="item.item.diascredito > 0"><b> TIPO:
                                Cliente
                                Credito</b></span>
                            <span v-if="item.item.diascredito == 0"><b>TIPO:
                                Cliente
                                Contado</b></span>
                          </v-col>


                        </template>
          </v-combobox>
          <v-tooltip v-if="nombreClienteNoExiste.length > 0" bottom>
            <template v-slot:activator="{ on }">
              <v-btn id="boton-mini2" v-on="on" class="my-1" color="grey darken-2" small dark
                     @click.prevent="abrirModalCrearCliente">
                <i style="font-size: 16px;" class="fa fa-user-plus mr-1"></i>
                Crear cliente
              </v-btn>
            </template>
            <span><b>Crear cliente: {{ nombreClienteNoExiste }}</b></span>
          </v-tooltip>
          <!------------------------------------------ fn Cliente --> 
          <p v-if="headerFactura.cliente==null"  style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b>Límite de Crédito.:</b>
            {{currencyFormatter(0)}}. <b> Plazo: </b>0 días. 
          </p>
          <p v-if="headerFactura.cliente!=null"  style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b>Límite de Crédito.:</b>
            {{currencyFormatter(headerFactura.cliente.limitecredito)}}. <b> Plazo: </b>{{headerFactura.cliente.diascredito}} días. 
          </p>

          <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> Cedula/RNC.........:</b> <span v-if="headerFactura.cliente!=null && headerFactura.cliente.hasOwnProperty('cedrnc') && headerFactura.cliente.cedrnc!=null ">{{headerFactura.cliente.cedrnc.trim()}}</span></p>
          <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> Ciudad.................:</b> <span v-if="headerFactura.cliente!=null">{{headerFactura.cliente.ciudad}}</span></p>
          <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> Teléfono..............:</b> {{selectTelefonoCliente(headerFactura.cliente) }}</p>

    </v-col>
    <!-- fn col header 1   --> 
   <!-- col header 2   --> 
    <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="4" sm="4" >
      <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="12" sm="12"  >
        <v-row no-gutters>
          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
            <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0 px-2"><b> {{infFact.nombre}} </b></p>
            <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0 px-2"><b> No: </b>{{infFact.secuencia}}</p>
          </v-col>

          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
            <div v-if="distribuidoraFarmaceutico==false">
            <v-combobox class="pt-2 fontSize13" autocomplete="off" dense outlined label="Centro de costo:" hide-details
                          :items="RtipoComprobante" :rules="[$rules.required]" item-text="descripcion"
                          v-model="headerFactura.centroCosto" @blur=""
                          @focus=""
                          v-on:blur="DataRetornInfHeaderFactura">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-contao"></i>
                          </template>
                        </v-combobox>
              </div>
              <div v-if="distribuidoraFarmaceutico==true">
                  <v-text-field class="pt-2 fontSize13"  label="# Pedido:" dense autocomplete="off" outlined type="number"
                        v-model.number="nOpedido" style="font-size: 12px;" @keyup.enter="keyupNopedido()">
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" class="fa fa-hashtag"></i>
                        </template>
                      </v-text-field>
              </div>


          </v-col>
        </v-row>
      </v-col>
        <!-- -----------------------------  Fecha Factura -->
        <!-- <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="12" sm="12" style="border: 1px solid #000000;"> </v-col> -->
                <v-text-field ref="RefTextFieldFecha"  class="pt-2 fontSize13" dense outlined type="date" label="Fecha Factura:" hide-details
                          v-model="headerFactura.fecha"
                          v-on:blur="DataRetornInfHeaderFactura"
                          id="formdisabledInput" :disabled="!modificando">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>
                     
      <!-- ----------------------------- fn Fecha Factura -->

      <!-- ----------------------------- tipocomprobante v-on:blur="DataRetornInfHeaderFactura"-->
      <v-combobox class="pt-2 fontSize13" autocomplete="off" dense outlined label=" Tipos de Comprobante:" hide-details
                          :items="RtipoComprobante" :rules="[$rules.required]" item-text="descripcion"
                          v-model="headerFactura.tipocomprobante" @blur="SelctCbTipoComprobante"
                          v-on:change="DataRetornInfHeaderFacturaChange('changeComprobante')"
                          @focus="cargarTipoComprobante"
                          id="formdisabledInput" :disabled="editando">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-tag"></i>
                          </template>
                        </v-combobox>
        <!-- ----------------------------- fn tipocomprobante -->

<!-- ----------------------------- Lista de Precios -->
<v-combobox v-if="this.headerFactura.activarListasPrecios"  id="formdisabledInput" disabled autocomplete="off" dense outlined label="Lista de Precios:" class="py-2 fontSize13"  :items="Rlista" hide-details
                          item-text="descripcion" v-model="headerFactura.listaPrecio" @blur="SelctCblista" 
                          @focus="cargarlista"
                          v-on:blur="DataRetornInfHeaderFactura">
                          <template v-slot:selection="{ attrs, item, parent, selected}">
                                <span class="black--text" v-if="item.hasOwnProperty('descripcion')" >{{item.descripcion.trim()}}</span>
                              </template>
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-list-ol"></i>
                          </template>
                        </v-combobox>
<!-- ----------------------------- fn Lista de Precios -->


    </v-col>
    <!-- fn col header 2   -->

    <!-- col header 3   -->
    <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="4" sm="4">
      
      <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="12" sm="12">
        <v-row no-gutters>
          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
<!------------------------------- Sucursal -->
<v-combobox class="pt-2 fontSize13" hide-details   autocomplete="off" dense outlined
                        id="formdisabledInput" disabled
                        label="Sucursal:" :items="RSucursal" item-text="descripcion" :rules="[$rules.required]"
                        v-model="headerFactura.sucursal" @blur="SelctCbSucursal" @focus="CargarRSucursal"
                        v-on:blur="DataRetornInfHeaderFactura">
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" class="fa fa-sitemap"></i>
                        </template>
      </v-combobox>
      <!------------------------------- fn Sucursal -->
          </v-col>
          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
            <v-text-field class="pt-2 fontSize13" hide-details  label="NCF" autocomplete="off" dense outlined v-model="headerFactura.ncf"
                        @blur="BlurCambioMayuscula"
                          style="font-size: 13px;"
                          id="formdisabledInput" :disabled="editando">
                          <template v-slot:prepend>
                            <i style="font-size: 18px;" class="fa fa-barcode"></i>
                          </template>
            </v-text-field>
          </v-col>

        </v-row>
      </v-col>

      

      <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="12" sm="12">
        <v-row no-gutters>
          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
           <!------------------------------- Moneda -->
      <v-combobox autocomplete="off" dense outlined label="Monedas" :items="Rmoneda" item-text="descripcion" class="pt-2 fontSize13" hide-details 
                  :rules="[$rules.required]" v-model="headerFactura.moneda"   @focus="cargarMoneda"
                  @blur="SelctCbMoneda"
                  v-on:blur="DataRetornInfHeaderFactura"
                  v-on:change="DataRetornInfHeaderFacturaChange('changeMoneda')"
                  id="formdisabledInput" :disabled="!modificando">
                  <template v-slot:prepend>
                    <i style="font-size: 20px;" class="fa fa-money"></i>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <!--{{ item.descripcion }} (  )-->
                    <span id="ImputColorDisable">{{ item.nombrecorto }}</span>
                  </template>
                  <template slot="item" slot-scope="item">
                    <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                    <v-col style="font-size: 13px;" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                      <p class="pa-0 ma-0 py-0 my-0"><b>{{ item.item.descripcion }} ({{ item.item.nombrecorto }})</b>
                      </p>
                    </v-col>
                  </template>
      </v-combobox>
      <!------------------------------- fn Moneda -->
          </v-col>

          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
            <VueAutonumeric label="Descuento cliente(Info.)"  dense outlined hide-details
                          id="formdisabledInput" disabled
                          autocomplete="off" :rules="[$rules.Numericc]"
                          v-model.number="headerFactura.descuento" @blur=""
                          class="pt-2 fontSize13 " @focus=""
                          v-on:blur="DataRetornInfHeaderFactura">
                          <template v-slot:prepend>
                            <i v-if="headerFactura.ValorPorc == true" style="font-size: 15px;"
                              class="fa fa-usd"></i>
                            <i v-if="headerFactura.ValorPorc == false" style="font-size: 15px;"
                              class="fa fa-percent"></i>
                          </template>
             </VueAutonumeric>
          </v-col>
        </v-row>
      </v-col>

      <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="12" sm="12">
        <v-row no-gutters>
          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
                <!-- -----------------------------  Tasa Compra -->
                <v-text-field hide-details class="pt-2 fontSize13" v-if="headerFactura.moneda != null" id="formdisabledInput" label="Tasa Compra:" dense outlined
                  v-model.number="headerFactura.moneda.tasa"
                  :disabled="!modificando"
                  v-on:blur="DataRetornInfHeaderFacturaChange('changeMoneda')">
                  <template v-slot:prepend>
                    <i style="font-size: 20px;" class="fa fa-usd"></i>
                  </template>
                </v-text-field>
          </v-col>
          <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="6" sm="12" >
          <!------------------------------- vendedor background-color="white"-->
          <v-combobox class="pt-2 fontSize13" ref="RefTextFieldBuscaVendedor" autocomplete="off"  hide-details
                      color="grey darken-4" dense outlined label="Vendedor:" :items="RVendedor" item-text="nombre"
                      style="font-size: 13px;" v-model="headerFactura.vendedor" @blur="SelctCbVendedorFactura"
                       @focus="cargarVendedorFactura" 
                      :rules="[$rules.required]"
                      v-on:blur="DataRetornInfHeaderFactura"
                      id="formdisabledInput" :disabled="!modificando">
                      <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-universal-access"></i> 
                      </template> 
                      <!-- margin-top="50px"style="font-size: 14px;" -->
                      <template slot="item" slot-scope="item">
                        <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                        <v-col style="border: 1px solid #000000; font-size: 13px; " class="pa-0 ma-0 py-0 my-0" cols="12"
                          md="12" sm="12">
                          <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b>NOMBRE:
                              {{ item.item.nombre }}</b></p>

                          <span class="pa-0 ma-0 py-0 my-0">
                            <span style="border: 1px dashed  #616161;"><b>TEL.: </b>{{ item.item.telefono }} </span>
                            <span style="border: 1px dashed  #616161;"><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                          </span>
                          <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b>DIRECCIÓN: </b>
                            {{ item.item.direccion }} </p>
                          <span style="border: 1px dashed  #616161;"
                            v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"><b> ARS
                              :{{ item.item.ars.nombre }}</b></span>
                          <span style="border: 1px dashed  #616161;" v-if="item.item.diascredito > 0"><b> TIPO: Cliente
                              Credito</b></span>
                          <span style="border: 1px dashed  #616161;" v-if="item.item.diascredito == 0"><b>TIPO: Cliente
                              Contado</b></span>
                        </v-col>

                      </template>

           </v-combobox>
          <!------------------------------- fn vendedor -->
         </v-col>
        </v-row>
      </v-col>

      <!-- ----------------------------- Dia de credito -->
          <v-text-field  label="Condición de pago" dense outlined class="pt-2 fontSize13" hide-details 
                          v-model="headerFactura.diascredito" @keyup="DiaCre"
                          v-on:blur="DataRetornInfHeaderFactura"
                          id="formdisabledInput" :disabled="!modificando">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-credit-card"></i>
                          </template>
                        </v-text-field>
      <!-- ----------------------------- fn Dia de credito -->

    </v-col>
    <!-- fn col header 3   -->
     </v-row>

      <!-- ------------------------------------------------------   alerta -->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%" :vertical="true" :timeout="120000"
      top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->
    <v-dialog v-model="dialogCrearCliente" persistent max-width="700">
      <v-card>
        <v-toolbar color="indigo" dark dense>
          <v-toolbar-title>Crear cliente</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarModalCrearCliente">
            <i class="fa fa-close" style="font-size: 20px;"></i>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-form ref="formCrearCliente">
            <v-text-field v-model="clienteNuevo.nombre" :rules="[$rules.required]" dense outlined
                          label="* Nombre:" autocomplete="off">
              <template v-slot:prepend>
                <i class="fa fa-font" style="font-size: 20px"></i>
              </template>
            </v-text-field>
            <v-text-field v-model="clienteNuevo.ciudad" :rules="[$rules.required]" dense outlined
                          label="* Ciudad:" autocomplete="off">
              <template v-slot:prepend>
                <i class="fa fa-map" style="font-size: 20px"></i>
              </template>
            </v-text-field>
            <v-textarea v-model="clienteNuevo.direccion" :rules="[$rules.required]" dense outlined
                        label="* Dirección:" autocomplete="off" rows="2">
              <template v-slot:prepend>
                <i class="fa fa-map-marker" style="font-size: 20px"></i>
              </template>
            </v-textarea>
            <v-combobox v-model="clienteNuevo.tipocliente" :items="RtipoClienteNuevo" :rules="[$rules.required]"
                        item-text="descripcion" dense outlined label="* Tipo de Cliente:" autocomplete="off"
                        @focus="cargarTipoClienteNuevo">
              <template v-slot:prepend>
                <i class="fa fa-users" style="font-size: 20px"></i>
              </template>
            </v-combobox>
            <v-combobox v-model="clienteNuevo.tipocomprobante"
                        :items="filterTipoComprobantePvItbis(RtipoComprobanteNuevo)" :rules="[$rules.required]"
                        item-text="descripcion" dense outlined label="* Tipos de Comprobante:" autocomplete="off"
                        @focus="cargarTipoComprobanteNuevo">
              <template v-slot:prepend>
                <i class="fa fa-tag" style="font-size: 20px"></i>
              </template>
            </v-combobox>
            <v-text-field v-model="clienteNuevo.cedrnc" v-mask="MakCelRnc" dense outlined maxlength="13"
                          autocomplete="off" label="Cedula/RNC:"
                          :rules="comprobanteExigeCedula() ? [$rules.required, $rules.RulesCelRncValidar] : [$rules.RulesCelRncValidar]">
              <template v-slot:prepend>
                <i style="font-size: 20px;" class="fa fa-id-card-o"></i>
              </template>
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="boton-mini3" color="success" small dark :disabled="guardandoClienteNuevo"
                 @click.prevent="guardarClienteNuevo">
            <i style="font-size: 20px;" class="fa fa-check-circle"></i>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-col> 
</template>
<script>
import numeral from "numeral";
import { EventBus } from "../../event-bus";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
  validaCedRnc } from "@/js/Funciones.js";
import VueAutonumeric from "../../components/AutoNumericNuevo";
export default {
  components: {
    VueAutonumeric
  },
  created() { 
 
  },
  mounted() {
      this.cargaInicial()
  },
  beforeDestroy() {

  },

  data: () => ({ 
    distribuidoraFarmaceutico:false,
    nOpedido:0,
    Rlista:[],
    RtipoComprobante:[],
    RDocumento:[],
    RCliente:[],
    nombreClienteNoExiste: "",
    dialogCrearCliente: false,
    MakCelRnc: "#############",
    guardandoClienteNuevo: false,
    clienteCreado: null,
    RtipoClienteNuevo: [],
    RtipoComprobanteNuevo: [],
    clienteNuevo: {
      nombre: "",
      ciudad: "",
      direccion: "",
      tipocliente: null,
      tipocomprobante: null,
      pais: null,
      limitecredito: 0,
      diascredito: 0,
      cedrnc: ""
    },
    RSucursal:[],
    Rmoneda:[],
    RVendedor:[],
    windowSize: { width: "auto", height: "auto" },
    headerFactura:{
      fecha:fechaNueva(),
      listaPrecio:null,
      tipocomprobante:null,
      documento:null,
      cliente:null,
      sucursal:null,
      moneda:null,
      vendedor:null,
      diascredito:0,
      centroCosto:null,
      ValorPorc:false,
      descuento:0,
      activarListasPrecios:false,
      ncf:''
    },
    
    infFact:{
      nombre:'**********',
      secuencia:0
    },
    aalert: {
      estado: false,
      color: null,
    },
   editando:false,
   modificando:false

  }),

  props: { 
cajaSelect: {
  required: false,
  type: Object,
  default: null
},
// salvarNuevo,editar,modificar:
modofactura: {
  required: false,
  type: String,
  default: "salvarNuevo"
}

},


  methods: { 
    fechaNueva,currencyFormatter,
    
  cargaInicial(){
    if(this.$store.getters.GetConfiguracionGeneral.configPv.activarListasPrecios!=null && this.$store.getters.GetConfiguracionGeneral.configPv.activarListasPrecios==true){
      this.headerFactura.activarListasPrecios=this.$store.getters.GetConfiguracionGeneral.configPv.activarListasPrecios
      var CONFIGPV=this.$store.getters.GetConfiguracionGeneral.configPv
      if(CONFIGPV.hasOwnProperty('listaPrecio') && CONFIGPV.listaPrecio!=null){
       this.headerFactura.listaPrecio = CONFIGPV.listaPrecio
      }
    }
  this.headerFactura. fecha=this.fechaNueva()
   this.headerFactura.diascredito=0
   this.headerFactura.cliente=null 
   this.headerFactura.vendedor=null 
   this.headerFactura.moneda = this.$store.getters.GetConfiguracionGeneral.config.monedabase
   this.headerFactura.tipocomprobante=this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion
   this.DataRetornInfHeaderFactura()
   this.distribuidoraFarmaceutico=this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico
    } ,
  cargarMonedaXdefecto(){
    this.headerFactura.moneda = this.$store.getters.GetConfiguracionGeneral.config.monedabase
    var OtrasConfPv = this.$store.getters.GetOtrasConfigPv;
      OtrasConfPv.moneda = this.headerFactura.moneda.descripcion.trim();
    this.DataRetornInfHeaderFactura()
    },

     cargarComprobanteXdefecto(){
    this.headerFactura.tipocomprobante=this.$store.getters.GetConfiguracionGeneral.configPv.comprobantefacturacion
    this.DataRetornInfHeaderFactura()
    },
  cargarlista() {
    this.$axios.get(this.$hostname + this.$hName + "/listasprecios/findallactivo", {
          headers: this.$store.getters.GetheadersAxios,})
        .then((res) => (this.Rlista = res.data));
  },

  SelctCblista() {
    var _this = this;
    setTimeout(function () {
  if (_this.headerFactura.listaPrecio == null) {
    _this.headerFactura.listaPrecio = "";
  }

  if (!_this.headerFactura.listaPrecio.hasOwnProperty('id')) {
    _this.headerFactura.listaPrecio = "";
    _this.headerFactura.listaPrecio = null;
    _this.cargarSelectlistaPrecioXdefecto()
    _this.alerta("Seleccione una lista de precio", "error");
    return;
  }
}, 300);

  },

  cargarSelectlistaPrecioXdefecto(){
if(this.headerFactura.activarListasPrecios==true){
    if(this.headerFactura.cliente!=null && this.headerFactura.cliente.listaPrecio!=null){
      this.headerFactura.listaPrecio=JSON.parse(JSON.stringify(this.headerFactura.cliente.listaPrecio))
    }else{
      var CONFIGPV=this.$store.getters.GetConfiguracionGeneral.configPv
      if(CONFIGPV.hasOwnProperty('listaPrecio') && CONFIGPV.listaPrecio!=null){
       this.headerFactura.listaPrecio = CONFIGPV.listaPrecio
      }
    }
  }

  },
    
  cargarTipoComprobante() {
      this.$axios
        .get(this.$hostname + this.$hName + "/tiponcf/findall", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RtipoComprobante = res.data));
  },


  SelctCbTipoComprobante() {
      var _this = this;
    setTimeout(function () {
  if (_this.headerFactura.tipocomprobante == null) {
    _this.headerFactura.tipocomprobante = "";
  }

  if (!_this.headerFactura.tipocomprobante.hasOwnProperty('codigo')) {
    _this.headerFactura.tipocomprobante = "";
    _this.headerFactura.tipocomprobante = null;
    _this.cargarComprobanteXdefecto()
    // _this.alerta("Seleccione un tipo de comprobante", "error");
  }
  _this.DataRetornInfHeaderFactura()
  //  _this.DataRetornInfHeaderFacturaChange('changeComprobante')
  return;
}, 300);
  },

 cargarDocumento(){

 console.log('Verklk-->',)
var USU=this.$store.getters.GetdatosInfUsu.usuario
var headers=this.$store.getters.GetheadersAxios
 if(USU.hasOwnProperty('sucursal') && USU.sucursal!=null){
this.$axios.get(this.$hostname + this.$hName + "/sucursal/findbyDocuSucursalById/"+USU.sucursal.codigo,{headers:headers})
        .then(res => {
       var LISTDO=res.data.listdocumentopv.filter((ee) => res.data.listcoddoc.includes(ee.codigo) && (ee.operacion.codigo==27 || ee.operacion.codigo==37));
       var LIST_DO_PE=res.data.listdocumentopv.filter((ee) => ee.operacion.codigo==37);
        var LIST_DO_COND_INV=[]
        if(res.data.hasOwnProperty("coddocinv") && res.data.coddocinv!=null){
          LIST_DO_COND_INV=res.data.listdocumentoconinv.filter((ee) =>  ee.codigo==res.data.coddocinv);
         }
        this.RDocumento = LISTDO.concat(LIST_DO_COND_INV).concat(LIST_DO_PE)
        console.log('this.RDocumento-->',this.RDocumento)
           })
        .catch(error => console.log(error));
 }else{

  this.$axios.get(this.$hostname + this.$hName + "/documentoventas/findallActivos/",{headers:headers})
        .then(res => {
          //this.RDocumento = res.data
        var LISTDO=res.data.filter((ee) => ee.operacion.codigo==27 || ee.operacion.codigo==37);
     this.$axios.get(this.$hostname +this.$hName +"/documento-inv/conduce",
      { headers: this.$store.getters.GetheadersAxios })
        .then(res2 => {
          this.RDocumento = LISTDO.concat(res2.data)
        });   
        })
        .catch(error => console.log(error));


 }



      },

     


SelctCbDocumento(){

  var _this = this;
    setTimeout(function () {
  if (_this.headerFactura.documento == null) {
    _this.headerFactura.documento = "";
  }

  if (!_this.headerFactura.documento.hasOwnProperty('codigo')) {
    _this.headerFactura.documento = "";
    _this.headerFactura.documento = null;
    _this.alerta("Seleccione un documento", "error");
    return;
  }
}, 300);

},


 // Un método que recibe un cliente y verifica en una lista si tiene telefono .
selectTelefonoCliente(e) {

      if ( e!=null && typeof e === 'object' && e.hasOwnProperty('telefonosClientesList') && e.telefonosClientesList!=null && e.telefonosClientesList.length > 0) {
        return e.telefonosClientesList[0].telefonosClientesPK.telefono.trim()
      } else { return ' ' }

},

async getChangeClienteBusqueda(e) {
if ( typeof e === 'object' && e != null) {

  this.nombreClienteNoExiste = ""
  if (e.statuscliente != null) {
    if (e.statuscliente == 2 || e.statuscliente == 3) {
      this.headerFactura.cliente = null
      this.alerta("Este cliente esta suspendido o cancelado, no puede Seleccinarlo", "error");
      return
    }
  }

  var obj = JSON.parse(JSON.stringify(e))
  obj.telefono = this.selectTelefonoCliente(e)
  if (e.cedrnc != null) { obj.cedrnc = e.cedrnc.trim() } else { obj.cedrnc = '' }

  if (e.diascredito != null && e.diascredito >0 ) { this.headerFactura.diascredito = e.diascredito} else { this.headerFactura.diascredito = 0 }
  if (e.vendedor != null) { 
    this.headerFactura.vendedor =  await this.findIdvendedor(e.vendedor );
  } else {this.headerFactura.vendedor =null }



  if (e.tipocomprobante != null) { this.headerFactura.tipocomprobante = e.tipocomprobante } else {this.headerFactura.tipocomprobante =null }
 
  var DESCUENTOVALOR=0
   var DESCUENTO=0
if(e.descuentovalor != null){DESCUENTOVALOR=e.descuentovalor}
if(e.descuento != null){DESCUENTO=e.descuento}

  if (DESCUENTOVALOR>0) { 
    this.headerFactura.descuento = DESCUENTOVALOR
    this.headerFactura.ValorPorc = true
  } 

  if (DESCUENTO>0) { 
    this.headerFactura.descuento = DESCUENTO
    this.headerFactura.ValorPorc = false
  } 


  if(DESCUENTOVALOR==0 && DESCUENTO==0){
    this.headerFactura.descuento = 0
    this.headerFactura.ValorPorc = false
  }
  // else{
  //   this.DataRetornInfHeaderFacturaChange('changeCliente')
  // }
  
  this.RedireccionFocus('RefTextFieldFecha')

}else{
  this.headerFactura.diascredito = 0
  this.headerFactura.vendedor =null
  this.headerFactura.tipocomprobante=null
  this.headerFactura.descuento = 0
    this.headerFactura.ValorPorc = false
}
},


cargarClienteBusqueda() {
  var filtroTipoCliente=3
      this.$axios
        .get(this.$hostname + this.$hName + "/clientes/findtodo/a/" + filtroTipoCliente + "/25/0", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RCliente = res.data));
},

CbFilcliente(e) {
      var filtroTipoCliente=3
      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/clientes/findtodo/" +
            (e.target.value === null || e.target.value.length==0 ? 'A' : e.target.value)+
            "/" + filtroTipoCliente + "/25/0",
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => (this.RCliente = res.data));
      }
},

SelctCbClienteBuscar() {
      var _this = this;
      setTimeout(function () {
        var cliente = _this.headerFactura.cliente
        if (cliente != null && typeof cliente === "object" && cliente.hasOwnProperty("codigo")) {
          _this.nombreClienteNoExiste = ""
          _this.cargarSelectlistaPrecioXdefecto()
          return
        }
        var nombre = typeof cliente === "string" ? cliente.trim() : ""
        _this.headerFactura.cliente = null
        if (nombre.length > 0) {
          _this.nombreClienteNoExiste = nombre
        } else {
          _this.nombreClienteNoExiste = ""
        }
        _this.cargarSelectlistaPrecioXdefecto()
      }, 300);
},
abrirModalCrearCliente() {
      this.clienteNuevo = {
        nombre: this.nombreClienteNoExiste,
        ciudad: "",
        direccion: "",
        tipocliente: null,
        tipocomprobante: null,
        pais: null,
        limitecredito: 0,
        diascredito: 0,
        cedrnc: ""
      }
      this.cargarTipoClienteNuevo()
      this.cargarTipoComprobanteNuevo()
      this.cargarInicioPaisCliente()
      this.dialogCrearCliente = true
},
cerrarModalCrearCliente() {
      this.dialogCrearCliente = false
},
cargarTipoClienteNuevo() {
      this.$axios
        .get(this.$hostname + this.$hName + "/tipoclientes/findallActivo", {
          headers: this.$store.getters.GetheadersAxios
        })
        .then((res) => (this.RtipoClienteNuevo = res.data))
},
cargarTipoComprobanteNuevo() {
      this.$axios
        .get(this.$hostname + this.$hName + "/tiponcf/findall", {
          headers: this.$store.getters.GetheadersAxios
        })
        .then((res) => (this.RtipoComprobanteNuevo = res.data))
},
cargarInicioPaisCliente() {
      this.$axios
        .get(this.$hostname + this.$hName + "/paises/findall", {
          headers: this.$store.getters.GetheadersAxios
        })
        .then((res) => {
          var paises = res.data
          var ObjRow = paises.filter((e) => e.id == 42)
          if (ObjRow.length > 0) {
            this.clienteNuevo.pais = JSON.parse(JSON.stringify(ObjRow[0]))
          }
        })
},
filterTipoComprobantePvItbis(List) {
      if (List == null) {
        return []
      }
      return List.filter((ee) => (ee.pv == true && ee.itbis == true) || (ee.descripcion != null && ee.descripcion.trim().toLowerCase().includes("regimen especial")) || ee.especial == true)
},
comprobanteExigeCedula() {
      var tipo = this.clienteNuevo.tipocomprobante
      if (tipo == null || typeof tipo !== "object" || tipo.codigo == undefined) {
        return false
      }
      return [2, 3, 4].includes(tipo.codigo)
},
guardarClienteNuevo() {
      if (this.$refs.formCrearCliente.validate() == false) {
        this.alerta("Los campos en rojo son requeridos", "error")
        return
      }
      var tipoCliente = this.clienteNuevo.tipocliente
      var tipoComprobante = this.clienteNuevo.tipocomprobante
      if (tipoCliente == null || typeof tipoCliente !== "object" || tipoCliente.codigo == undefined) {
        this.alerta("Seleccione un tipo de cliente", "error")
        return
      }
      if (tipoComprobante == null || typeof tipoComprobante !== "object" || tipoComprobante.codigo == undefined) {
        this.alerta("Seleccione un Tipo Comprobante", "error")
        return
      }
      if (this.clienteNuevo.pais == null) {
        this.alerta("No se cargó el país", "error")
        return
      }
      var cedrnc = this.clienteNuevo.cedrnc == null ? "" : this.clienteNuevo.cedrnc.trim()
      var COD_TIPO_COMP = [2, 3, 4]
      if (cedrnc.length == 0 && COD_TIPO_COMP.includes(tipoComprobante.codigo)) {
        this.alerta(` El comprobante: ${tipoComprobante.descripcion.trim()} Requiere un Cédula/RNC `, "error")
        return
      }
      if (cedrnc.length > 0) {
        var CEDULA = cedrnc.replace("-", "")
        if (validaCedRnc(CEDULA) == false) {
          var NOM = CEDULA.length > 10 ? "CEDULA" : "RNC"
          this.alerta(`${NOM} Invalida `, "error")
        }
      }
      if (this.clienteNuevo.limitecredito == null) {
        this.clienteNuevo.limitecredito = 0
      }
      if (this.guardandoClienteNuevo == true) {
        return
      }
      this.guardandoClienteNuevo = true
      EventBus.$emit("loading", true)
      var obj = {
        codigo: 0,
        nombre: this.clienteNuevo.nombre,
        cedrnc: cedrnc,
        ciudad: this.clienteNuevo.ciudad,
        direccion: this.clienteNuevo.direccion,
        pais: this.clienteNuevo.pais,
        tipocliente: tipoCliente,
        tipocomprobante: tipoComprobante,
        limitecredito: 0,
        diascredito: 0,
        activado: true,
        vendedor: null,
        tipo: tipoCliente.descripcion
      }
      var _this = this
      this.$axios
        .post(this.$hostname + this.$hName + "/clientes/save", obj, {
          headers: this.$store.getters.GetheadersAxios
        })
        .then(async (res) => {
          var cliente = res.data
          _this.clienteCreado = cliente
          _this.guardandoClienteNuevo = false
          EventBus.$emit("loading", false)
          if (cliente != null && cliente.codigo != null && cliente.codigo > 0) {
            var nombre = cliente.nombre == null ? "" : cliente.nombre.trim()
            cliente.codnom = cliente.codigo + " - " + nombre
            if (_this.RCliente == null) {
              _this.RCliente = []
            }
            _this.RCliente.push(cliente)
            _this.headerFactura.cliente = cliente
            await _this.getChangeClienteBusqueda(cliente)
            _this.DataRetornInfHeaderFacturaChange("changeCliente")
          }
          _this.dialogCrearCliente = false
          _this.nombreClienteNoExiste = ""
          _this.alerta("Dato guardado correctamente", "bien")
        })
        .catch((error) => {
          _this.guardandoClienteNuevo = false
          var MESSAGE = ""
          if (error.response) {
            MESSAGE = error.response.data
          } else if (error.request) {
            MESSAGE = error.request
          } else {
            MESSAGE = error.message
          }
          if (MESSAGE == null || String(MESSAGE).trim().length == 0) {
            MESSAGE = "DATO NO GUARDADO CORRECTAMENTE"
          }
          _this.alerta(MESSAGE, "error")
        })
},

DataRetornInfHeaderFacturaChange(nombreChange){
  var _this=this;
  setTimeout(function(){ 

    if(_this.headerFactura.moneda==null){
      _this.headerFactura.moneda = _this.$store.getters.GetConfiguracionGeneral.config.monedabase
    }

    var OBJ={
    nombreChange:nombreChange,
    headerFactura:_this.headerFactura
  }
   _this.DataRetornInfHeaderFactura()
  _this.$emit("DataRetornInfHeaderFacturaChange", OBJ)
  }, 300);

},

CargarRSucursal() {

this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: this.$store.getters.GetheadersAxios }).then(res => {
  this.RSucursal = JSON.parse(JSON.stringify(res.data));
});

},
SelctCbSucursal() {
var _this = this;
setTimeout(function () {
  if (_this.headerFactura.sucursal == null) {
    _this.headerFactura.sucursal = "";
  }

  if (!_this.headerFactura.sucursal.hasOwnProperty('codigo')) {
    _this.headerFactura.sucursal = "";
    _this.headerFactura.sucursal = null;
    return;
  }
}, 300);
},

cargarMoneda() {
      this.$axios
        .get(this.$hostname + this.$hName + "/monedas/findallActivos/", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.Rmoneda = res.data));
},
   
SelctCbMoneda() {
var _this = this;
setTimeout(function () {
  if (_this.headerFactura.moneda == null) {
    _this.headerFactura.moneda = "";
  }

  if (!_this.headerFactura.moneda.hasOwnProperty('codigo')) {
    _this.headerFactura.moneda = "";
    _this.headerFactura.moneda = null;
    _this.cargarMonedaXdefecto()
    return;
  }
}, 300);
},

cargarVendedorFactura() {
      this.$axios
        .get(this.$hostname + this.$hName + "/vendedores/findallactiv", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RVendedor = res.data));
},

SelctCbVendedorFactura() {
var _this = this;
setTimeout(function () {
  if (_this.headerFactura.vendedor == null) {
    _this.headerFactura.vendedor = "";
  }

  if (!_this.headerFactura.vendedor.hasOwnProperty('codigo')) {
    _this.headerFactura.vendedor = "";
    _this.headerFactura.vendedor = null;
    return;
  }
}, 300);

},

DiaCre(e) {
      if (e.key) {
        var mynumeral = require("numeral");
        this.headerFactura.diascredito = mynumeral(
          this.headerFactura.diascredito
        ).value();
        if (this.headerFactura.diascredito == null) {
          this.headerFactura.diascredito = 0;
        }
      } else {
        console.log("no se puede poner letras o signos");
      }
},


async findIdvendedor(codigo){
      return  new Promise((resolve, reject) => {
      var VARLINK=`vendedores/find/${codigo}`
        this.$axios.get(this.$hostname + this.$hName + '/' + VARLINK, { headers: this.$store.getters.GetheadersAxios })
        .then(res => { 
          if(res.data.hasOwnProperty('codigo')){
            resolve(res.data)
          } else{
            resolve(null)
          }  
        })
        .catch(error => {
            resolve(null)
          });  

        });
},

DataRetornInfHeaderFactura(){
  var _this=this;
  setTimeout(function(){ 
    if(_this.headerFactura.moneda==null){
      _this.headerFactura.moneda = _this.$store.getters.GetConfiguracionGeneral.config.monedabase
    }
    _this.$emit("DataRetornInfHeaderFactura", _this.headerFactura)
  }, 300);

},

 // Convirtiendo la cadena a mayúsculas.
 BlurCambioMayuscula(){

if(this.headerFactura.ncf.length>0){
  this.headerFactura.ncf=JSON.parse(JSON.stringify(this.headerFactura.ncf.toUpperCase()))  
}

},

getInformacionFactura(e){
// e.documento.
this.infFact.secuencia=e.secuencia

if(e.documento!=null && e.documento.operacion.codigo==27){
  this.infFact.nombre='FACTURA'
  }
if(e.documento!=null && e.documento.operacion.codigo==35){
  this.infFact.nombre='CONDUCE'
  }

  if(e.documento!=null && e.documento.operacion.codigo==37){
  this.infFact.nombre='PEDIDO'
  }

  /*this.infFact={
      nombre:'',
      secuencia:0
    },*/

},

changeDocumentoInfFact(e){
  var _this=this;
  setTimeout(function(){
  if(e!=null && e.hasOwnProperty('codigo')){
    var OBJ={
        documento:e.codigo,
        operacion:e.operacion.codigo
      }
    _this.GetUltimaSecuenciaFactura(OBJ)
  if(e.operacion.codigo==27){
  _this.infFact.nombre='FACTURA'
  }
if(e.operacion.codigo==35){
  _this.infFact.nombre='CONDUCE'
  }
  if(e.operacion.codigo==37){
  _this.infFact.nombre='PEDIDO'
  }
  }else{
    _this.infFact. nombre='**********'
    _this.infFact.secuencia=0
  }
  
  }, 300);

},


  // Usca el ultimi secuencia factura
  async GetUltimaSecuenciaFactura(e){
    // var _this = this;
if(e.operacion==27){
      this.$axios.get(this.$hostname +this.$hName +"/pv/ultimoSecuenciaFactura/"+
          e.operacion +"/"+e.documento,
          { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.infFact.secuencia=res.data
          /*console.log('---GetUltimaSecuenciaFactura---')
          console.log(res.data)*/
         /* this.CierresCajas.cierrescajasPK.secuencia = res.data;
          this.CierresCajas.cierrescajasPK.caja= this.cajaSelect.codigo
          setTimeout(function(){ 
            _this.updateConfiguracion()
            _this.$emit("DataRetornCierre", _this.CierresCajas)
            _this.cargarDenominacion(res.data)
          }, 300);*/
        });
}

if(e.operacion==35){ 
  this.$axios.get(this.$hostname +this.$hName +"/conduce/ultimoSecuenciaConduce/"+
          e.operacion +"/"+e.documento,
          { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.infFact.secuencia=res.data
        });
}

if(e.operacion==37){
      this.$axios.get(this.$hostname +this.$hName +"/pedidosfacturacion/ultimoSecuenciaPedido/",
          { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.infFact.secuencia=res.data
        });
}



      
  },

  RedireccionFocus(e) {
      var _this = this;
      setTimeout(function () { _this.$refs[e].focus() }, 300)
    },


    keyupNopedido(){
         var sec=this.nOpedido,
          fecini=null,
          fecfin=null,
          cliente = null;
          //var sucursal=_this.cajaSelect.sucursal.codigo;
          var sucursal=this.headerFactura.sucursal.codigo;
    this.$axios.get(this.$hostname +this.$hName +
            "/pedidosfacturacion/findPedido/" +
            sec +"/" +fecini +"/" +fecfin +
            "/" +cliente +"/false" +
            "/" +sucursal+"/"+100+"/" +0,
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
            //*this.TotalRegistros = res.data.cantidad,
             if(res.data.listas.length==0){

                this.alerta(`NOTA: no existe pedido con el número: (${this.nOpedido}) que digito. `, "error");
                var OBJ={
                  idpedida:0,
                  pedidoFact:null
                }
                this.$emit("DataListPedido", OBJ)

                 var _this = this;
      setTimeout(function () { _this.nOpedido=0 }, 900)


             }else{
              var OBJ={
                  idpedida:this.nOpedido,
                  pedidoFact:res.data.listas[0]
                }
                this.$emit("DataListPedido", OBJ)
             }
          });


    },


 GetColorHeader(){
    // wsedfksajdfkj mme quede aquii
   /* unidadesProductosPK.producto
unidadesProductosPK.unidad*/
    var SCHEMA_SYS=this.$store.getters.GetheadersAxios["X-TENANT-ID"].toUpperCase()
    if(SCHEMA_SYS==='RUIZCODB'){
      //dd4b39
      return '#FFCDD2'
    }else{
      return 'transparent'
    }


  // var PRODUCTOSELEC=this.$refs.RefPvBusquedaAgregarProducto.buscarProduc
  // if(PRODUCTOSELEC!=null){

  //   if(PRODUCTOSELEC!=null && PRODUCTOSELEC.hasOwnProperty('indx') && PRODUCTOSELEC.indx== e.indx && PRODUCTOSELEC.unidadesProductosPK.producto ==e.unidadesProductosPK.producto && PRODUCTOSELEC.unidadesProductosPK.unidad ==e.unidadesProductosPK.unidad){
  //   return '#FF9800'
  // }else{
  //   return 'transparent'
  // }

  // }else{

  //   if(this.ProductoSelectMarca!=null && this.ProductoSelectMarca.hasOwnProperty('indx') && this.ProductoSelectMarca.indx== e.indx && this.ProductoSelectMarca.unidadesProductosPK.producto ==e.unidadesProductosPK.producto && this.ProductoSelectMarca.unidadesProductosPK.unidad ==e.unidadesProductosPK.unidad){
  //   return '#BDBDBD'
  // }else{
  //   return 'transparent'
  // }
    
  // }
  


  },


alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        // this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);
        EventBus.$emit("loading", false);
        this.ejecucion = true;
      }
},


  },
  computed: { 
    GetEjecucion() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
      if(this.cajaSelect!=null && this.cajaSelect.hasOwnProperty('codigo')){
        this.headerFactura.sucursal= this.cajaSelect.sucursal
      }

      if(this.headerFactura.tipocomprobante==null){
        this.cargarComprobanteXdefecto()
        // this.headerFactura.tipocomprobante
      }

    var CLIENTE=this.headerFactura.cliente
var _this=this;
setTimeout(function(){ 
  if(_this.headerFactura.cliente!=null && _this.headerFactura.cliente.hasOwnProperty('codigo') && !_this.headerFactura.cliente.hasOwnProperty('codnom') ){
    CLIENTE.codnom=`${_this.headerFactura.cliente.codigo} - ${_this.headerFactura.cliente.nombre.trim()}` 
    _this.headerFactura.cliente=JSON.parse(JSON.stringify(CLIENTE))
  }
}, 300);

      // salvarNuevo,editar,modificar:
   
  if(this.modofactura==='salvarNuevo'){
    this.editando=false
    this.modificando=true
   }
   if(this.modofactura==='editar'){
    this.editando=true
    this.modificando=false
   }

   if(this.modofactura==='modificar'){
    this.editando=true
    this.modificando=true
   }



     },

},
};
</script>
<style lang="scss">
.colorNombre {
  color: #000000;
}
@media screen and (max-width: 850px) {

  #boton-mini2 {
    font-size: 0.45px;
  }

}

@media screen and (max-width: 900px) {

  #boton-mini3 {
    font-size: 0.45px;
  }

}


</style>